import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiClock, FiMenu, FiX, FiMapPin } = FiIcons;
const { FaWhatsapp } = FaIcons;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="bg-blue-900 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between text-sm">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiMapPin} className="text-yellow-400" />
              <span>Manchester & Surrounding Areas</span>
            </div>
            <div className="hidden md:flex items-center space-x-2 text-yellow-400 font-bold">
              <SafeIcon icon={FiClock} />
              <span>24/7 Rapid Response</span>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <a href="https://wa.me/447459014304" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:text-[#25D366] transition-colors">
              <SafeIcon icon={FaWhatsapp} />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>
            <a href="tel:+447459014304" className="flex items-center space-x-2 hover:text-yellow-400 transition-colors font-bold">
              <SafeIcon icon={FiPhone} />
              <span>07459 014304</span>
            </a>
          </div>
        </div>
      </div>

      <nav className="px-4 py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-4 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://i.postimg.cc/59sGRNrb/LLOGO.png" 
              alt="ALVI GROUP LTD Logo" 
              className="h-10 w-auto"
            />
            <div className="hidden sm:block text-left">
              <h1 className="text-lg font-bold text-gray-900 leading-none">ALVI GROUP LTD</h1>
              <p className="text-[10px] uppercase tracking-wider text-blue-600 font-bold">Rapid Drainage Solutions</p>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Services</button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Why RDS</button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Reviews</button>
            <a href="tel:+447459014304" className="bg-red-600 text-white px-6 py-2 rounded-lg font-bold hover:bg-red-700 transition-all transform hover:scale-105 flex items-center space-x-2">
              <SafeIcon icon={FiPhone} />
              <span>Emergency Call</span>
            </a>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2">
            <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        {isMobileMenuOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} className="md:hidden mt-4 py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('services')} className="text-left py-2 font-medium">Services</button>
              <button onClick={() => scrollToSection('about')} className="text-left py-2 font-medium">About</button>
              <a href="tel:+447459014304" className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold text-center">Call: 07459 014304</a>
              <a href="https://wa.me/447459014304" className="bg-[#25D366] text-white px-6 py-3 rounded-lg font-bold text-center">WhatsApp Us</a>
            </div>
          </motion.div>
        )}
      </nav>
    </motion.header>
  );
};

export default Header;